<template v-slot="props">
  <ul v-if="fieldValues && Object.keys(fieldValues).length > 0" class="item" style="padding-top: 10px;">
    <li v-for="(value, key) in fieldValues" v-if="value && !Array.isArray(value)"><strong>{{ formatKey(key) }}</strong>: {{ value }}<br/></li>
  </ul>
</template>

<script>
import {formatTaskFieldKey} from '@/utilities/utils'

export default {
  props: ['data'],
  computed: {
    task() {
      return this.data
    },
    fieldValues() {
      return this.data && this.data.fieldValues ? this.data.fieldValues : {}
    },
    taskTemplates() {
      return this.$store.get('tasks/templates/results')
    }
  },
  methods: {
    formatKey(fieldKey) {
      return formatTaskFieldKey(this.taskTemplates, this.task, fieldKey)
    }
  }
}
</script>
